import { Box, Avatar, Heading, Text } from "@chakra-ui/react";
import React from "react";
import { useSelector } from "react-redux";
import { User } from "../../../utils/types/user";
import { RootState } from "../../../redux/reducer/rootReducer";

const UserProfile = () => {
  // Replace with actual user data
  const user: User | null = useSelector((state: RootState) => state.user.user);

  return (
    <Box textAlign="center" gap={4} borderWidth="1px" borderRadius="lg" p={4}>
      <Avatar size="2xl" src={user?.first_name} mb={4} />
      <Heading as="h1" size="xl" mb={2}>
        {user?.first_name} {user?.middle_name} {user?.last_name}
      </Heading>
      <Text fontSize="lg" color="gray.600" mb={4}>
        Email: {user?.email}
      </Text>
      <Text fontSize="lg" color="gray.600" mb={4}>
        Phone Number: N/A
      </Text>
      <Text fontSize="lg" color="gray.600" mb={4}>
        Facility: {user?.facility?.name}
      </Text>
      <Text fontSize="lg" color="gray.600" mb={4}>
        Position: {user?.position}
      </Text>
      {/* Add more user information here */}
    </Box>
  );
};

export default UserProfile;
